export enum CngPermissionsEnum {
    UPDATE = "update_cng_product",
    INSERT = "insert_cng_product",
    READ = "read_cng_product",
    DELETE = "delete_cng_product",
}
